import { isThemeToken } from '@nettbureau/theme';
import { isNumber } from 'radash';

/**
 * Parses a spacing value to its CSS spacing representation based on the theme.
 *
 * @param theme - The theme object.
 * @param spacing - The spacing value or values to resolve.
 */ function parseSpacing(theme, spacing) {
    return [
        spacing
    ].flat().map((value)=>isNumber(value) ? `${theme.scales.base * value}px` : isThemeToken(value, theme.spacings) ? `${theme.spacings[value]}px` : value).join(' ');
}

export { parseSpacing };
//# sourceMappingURL=spacing.js.map
